import React, { useEffect, useRef, useState, useMemo } from "react";
import * as d3 from "d3";
import COLOR_ORDINAL from "../COLOR_ORDINAL";
import styles from "./styles.module.scss";
import Legend from "../Legend";
import STATISTIC_TYPES, {
    FIND_STATISTIC_TYPE_BY_VALUE,
} from "../STATISTIC_TYPES";
import ChartNote from "../ChartNote";
import formatNumber from "../../utils/formatNumber";

const MOCK_DATA = [
    {
        name: "1萬元以上~未滿2萬元",
        data: [
            {
                name: "1萬元以上~未滿2萬元",
                value: "0.1813",
            },
            {
                name: "沒有額外花費",
                value: "0.2912",
            },
            {
                name: "3千元以上~未滿4千元",
                value: "0.0000",
            },
            {
                name: "不記得",
                value: "0.0000",
            },
            {
                name: "4千元以上~未滿5千元",
                value: "0.1776",
            },
            {
                name: "2千元以上~未滿3千元",
                value: "0.1482",
            },
            {
                name: "1千元以上~未滿2千元",
                value: "0.0470",
            },
            {
                name: "7千元以上~未滿8千元",
                value: "0.0000",
            },
            {
                name: "不到1千元",
                value: "0.0000",
            },
            {
                name: "2萬元以上，約萬元【訪員請紀錄】",
                value: "0.0000",
            },
            {
                name: "9千元以上~未滿1萬元",
                value: "0.0468",
            },
            {
                name: "8千元以上~未滿9千元",
                value: "0.0000",
            },
            {
                name: "5千元以上~未滿6千元",
                value: "0.1079",
            },
            {
                name: "6千元以上~未滿7千元",
                value: "0.0000",
            },
        ],
    },
    {
        name: "1千元以上~未滿2千元",
        data: [
            {
                name: "1萬元以上~未滿2萬元",
                value: "0.0000",
            },
            {
                name: "沒有額外花費",
                value: "0.6259",
            },
            {
                name: "3千元以上~未滿4千元",
                value: "0.0000",
            },
            {
                name: "不記得",
                value: "0.0000",
            },
            {
                name: "4千元以上~未滿5千元",
                value: "0.0781",
            },
            {
                name: "2千元以上~未滿3千元",
                value: "0.0778",
            },
            {
                name: "1千元以上~未滿2千元",
                value: "0.0449",
            },
            {
                name: "7千元以上~未滿8千元",
                value: "0.0000",
            },
            {
                name: "不到1千元",
                value: "0.0943",
            },
            {
                name: "2萬元以上，約萬元【訪員請紀錄】",
                value: "0.0000",
            },
            {
                name: "9千元以上~未滿1萬元",
                value: "0.0412",
            },
            {
                name: "8千元以上~未滿9千元",
                value: "0.0000",
            },
            {
                name: "5千元以上~未滿6千元",
                value: "0.0378",
            },
            {
                name: "6千元以上~未滿7千元",
                value: "0.0000",
            },
        ],
    },
    {
        name: "6千元以上~未滿7千元",
        data: [
            {
                name: "1萬元以上~未滿2萬元",
                value: "0.0000",
            },
            {
                name: "沒有額外花費",
                value: "0.1050",
            },
            {
                name: "3千元以上~未滿4千元",
                value: "0.5041",
            },
            {
                name: "不記得",
                value: "0.3909",
            },
            {
                name: "4千元以上~未滿5千元",
                value: "0.0000",
            },
            {
                name: "2千元以上~未滿3千元",
                value: "0.0000",
            },
            {
                name: "1千元以上~未滿2千元",
                value: "0.0000",
            },
            {
                name: "7千元以上~未滿8千元",
                value: "0.0000",
            },
            {
                name: "不到1千元",
                value: "0.0000",
            },
            {
                name: "2萬元以上，約萬元【訪員請紀錄】",
                value: "0.0000",
            },
            {
                name: "9千元以上~未滿1萬元",
                value: "0.0000",
            },
            {
                name: "8千元以上~未滿9千元",
                value: "0.0000",
            },
            {
                name: "5千元以上~未滿6千元",
                value: "0.0000",
            },
            {
                name: "6千元以上~未滿7千元",
                value: "0.0000",
            },
        ],
    },
    {
        name: "沒有額外花費",
        data: [
            {
                name: "1萬元以上~未滿2萬元",
                value: "0.0174",
            },
            {
                name: "沒有額外花費",
                value: "0.7455",
            },
            {
                name: "3千元以上~未滿4千元",
                value: "0.0000",
            },
            {
                name: "不記得",
                value: "0.0310",
            },
            {
                name: "4千元以上~未滿5千元",
                value: "0.0224",
            },
            {
                name: "2千元以上~未滿3千元",
                value: "0.0268",
            },
            {
                name: "1千元以上~未滿2千元",
                value: "0.0201",
            },
            {
                name: "7千元以上~未滿8千元",
                value: "0.0073",
            },
            {
                name: "不到1千元",
                value: "0.0538",
            },
            {
                name: "2萬元以上，約萬元【訪員請紀錄】",
                value: "0.0272",
            },
            {
                name: "9千元以上~未滿1萬元",
                value: "0.0000",
            },
            {
                name: "8千元以上~未滿9千元",
                value: "0.0000",
            },
            {
                name: "5千元以上~未滿6千元",
                value: "0.0485",
            },
            {
                name: "6千元以上~未滿7千元",
                value: "0.0000",
            },
        ],
    },
    {
        name: "不記得",
        data: [
            {
                name: "1萬元以上~未滿2萬元",
                value: "0.0991",
            },
            {
                name: "沒有額外花費",
                value: "0.3849",
            },
            {
                name: "3千元以上~未滿4千元",
                value: "0.0000",
            },
            {
                name: "不記得",
                value: "0.4899",
            },
            {
                name: "4千元以上~未滿5千元",
                value: "0.0261",
            },
            {
                name: "2千元以上~未滿3千元",
                value: "0.0000",
            },
            {
                name: "1千元以上~未滿2千元",
                value: "0.0000",
            },
            {
                name: "7千元以上~未滿8千元",
                value: "0.0000",
            },
            {
                name: "不到1千元",
                value: "0.0000",
            },
            {
                name: "2萬元以上，約萬元【訪員請紀錄】",
                value: "0.0000",
            },
            {
                name: "9千元以上~未滿1萬元",
                value: "0.0000",
            },
            {
                name: "8千元以上~未滿9千元",
                value: "0.0000",
            },
            {
                name: "5千元以上~未滿6千元",
                value: "0.0000",
            },
            {
                name: "6千元以上~未滿7千元",
                value: "0.0000",
            },
        ],
    },
    {
        name: "不到1千元",
        data: [
            {
                name: "1萬元以上~未滿2萬元",
                value: "0.0000",
            },
            {
                name: "沒有額外花費",
                value: "0.3725",
            },
            {
                name: "3千元以上~未滿4千元",
                value: "0.0707",
            },
            {
                name: "不記得",
                value: "0.0000",
            },
            {
                name: "4千元以上~未滿5千元",
                value: "0.2806",
            },
            {
                name: "2千元以上~未滿3千元",
                value: "0.2160",
            },
            {
                name: "1千元以上~未滿2千元",
                value: "0.0129",
            },
            {
                name: "7千元以上~未滿8千元",
                value: "0.0000",
            },
            {
                name: "不到1千元",
                value: "0.0472",
            },
            {
                name: "2萬元以上，約萬元【訪員請紀錄】",
                value: "0.0000",
            },
            {
                name: "9千元以上~未滿1萬元",
                value: "0.0000",
            },
            {
                name: "8千元以上~未滿9千元",
                value: "0.0000",
            },
            {
                name: "5千元以上~未滿6千元",
                value: "0.0000",
            },
            {
                name: "6千元以上~未滿7千元",
                value: "0.0000",
            },
        ],
    },
    {
        name: "2萬元以上，約萬元【訪員請紀錄】",
        data: [
            {
                name: "1萬元以上~未滿2萬元",
                value: "0.0474",
            },
            {
                name: "沒有額外花費",
                value: "0.3312",
            },
            {
                name: "3千元以上~未滿4千元",
                value: "0.0000",
            },
            {
                name: "不記得",
                value: "0.0964",
            },
            {
                name: "4千元以上~未滿5千元",
                value: "0.0457",
            },
            {
                name: "2千元以上~未滿3千元",
                value: "0.0000",
            },
            {
                name: "1千元以上~未滿2千元",
                value: "0.0000",
            },
            {
                name: "7千元以上~未滿8千元",
                value: "0.0000",
            },
            {
                name: "不到1千元",
                value: "0.0000",
            },
            {
                name: "2萬元以上，約萬元【訪員請紀錄】",
                value: "0.0346",
            },
            {
                name: "9千元以上~未滿1萬元",
                value: "0.2381",
            },
            {
                name: "8千元以上~未滿9千元",
                value: "0.0000",
            },
            {
                name: "5千元以上~未滿6千元",
                value: "0.2066",
            },
            {
                name: "6千元以上~未滿7千元",
                value: "0.0000",
            },
        ],
    },
    {
        name: "4千元以上~未滿5千元",
        data: [
            {
                name: "1萬元以上~未滿2萬元",
                value: "0.0000",
            },
            {
                name: "沒有額外花費",
                value: "0.6251",
            },
            {
                name: "3千元以上~未滿4千元",
                value: "0.0000",
            },
            {
                name: "不記得",
                value: "0.0000",
            },
            {
                name: "4千元以上~未滿5千元",
                value: "0.0000",
            },
            {
                name: "2千元以上~未滿3千元",
                value: "0.0000",
            },
            {
                name: "1千元以上~未滿2千元",
                value: "0.0000",
            },
            {
                name: "7千元以上~未滿8千元",
                value: "0.0000",
            },
            {
                name: "不到1千元",
                value: "0.0000",
            },
            {
                name: "2萬元以上，約萬元【訪員請紀錄】",
                value: "0.0000",
            },
            {
                name: "9千元以上~未滿1萬元",
                value: "0.0000",
            },
            {
                name: "8千元以上~未滿9千元",
                value: "0.0000",
            },
            {
                name: "5千元以上~未滿6千元",
                value: "0.0000",
            },
            {
                name: "6千元以上~未滿7千元",
                value: "0.3749",
            },
        ],
    },
    {
        name: "5千元以上~未滿6千元",
        data: [
            {
                name: "1萬元以上~未滿2萬元",
                value: "0.0000",
            },
            {
                name: "沒有額外花費",
                value: "0.5492",
            },
            {
                name: "3千元以上~未滿4千元",
                value: "0.0000",
            },
            {
                name: "不記得",
                value: "0.0000",
            },
            {
                name: "4千元以上~未滿5千元",
                value: "0.0411",
            },
            {
                name: "2千元以上~未滿3千元",
                value: "0.2730",
            },
            {
                name: "1千元以上~未滿2千元",
                value: "0.0000",
            },
            {
                name: "7千元以上~未滿8千元",
                value: "0.0000",
            },
            {
                name: "不到1千元",
                value: "0.0000",
            },
            {
                name: "2萬元以上，約萬元【訪員請紀錄】",
                value: "0.0000",
            },
            {
                name: "9千元以上~未滿1萬元",
                value: "0.0571",
            },
            {
                name: "8千元以上~未滿9千元",
                value: "0.0000",
            },
            {
                name: "5千元以上~未滿6千元",
                value: "0.0796",
            },
            {
                name: "6千元以上~未滿7千元",
                value: "0.0000",
            },
        ],
    },
    {
        name: "2千元以上~未滿3千元",
        data: [
            {
                name: "1萬元以上~未滿2萬元",
                value: "0.0000",
            },
            {
                name: "沒有額外花費",
                value: "0.5855",
            },
            {
                name: "3千元以上~未滿4千元",
                value: "0.0000",
            },
            {
                name: "不記得",
                value: "0.0000",
            },
            {
                name: "4千元以上~未滿5千元",
                value: "0.1341",
            },
            {
                name: "2千元以上~未滿3千元",
                value: "0.0755",
            },
            {
                name: "1千元以上~未滿2千元",
                value: "0.1067",
            },
            {
                name: "7千元以上~未滿8千元",
                value: "0.0000",
            },
            {
                name: "不到1千元",
                value: "0.0000",
            },
            {
                name: "2萬元以上，約萬元【訪員請紀錄】",
                value: "0.0000",
            },
            {
                name: "9千元以上~未滿1萬元",
                value: "0.0982",
            },
            {
                name: "8千元以上~未滿9千元",
                value: "0.0000",
            },
            {
                name: "5千元以上~未滿6千元",
                value: "0.0000",
            },
            {
                name: "6千元以上~未滿7千元",
                value: "0.0000",
            },
        ],
    },
    {
        name: "3千元以上~未滿4千元",
        data: [
            {
                name: "1萬元以上~未滿2萬元",
                value: "0.0000",
            },
            {
                name: "沒有額外花費",
                value: "0.0000",
            },
            {
                name: "3千元以上~未滿4千元",
                value: "0.0000",
            },
            {
                name: "不記得",
                value: "0.0000",
            },
            {
                name: "4千元以上~未滿5千元",
                value: "0.0000",
            },
            {
                name: "2千元以上~未滿3千元",
                value: "0.0000",
            },
            {
                name: "1千元以上~未滿2千元",
                value: "0.6786",
            },
            {
                name: "7千元以上~未滿8千元",
                value: "0.0000",
            },
            {
                name: "不到1千元",
                value: "0.0000",
            },
            {
                name: "2萬元以上，約萬元【訪員請紀錄】",
                value: "0.0000",
            },
            {
                name: "9千元以上~未滿1萬元",
                value: "0.0000",
            },
            {
                name: "8千元以上~未滿9千元",
                value: "0.3214",
            },
            {
                name: "5千元以上~未滿6千元",
                value: "0.0000",
            },
            {
                name: "6千元以上~未滿7千元",
                value: "0.0000",
            },
        ],
    },
    {
        name: "9千元以上~未滿1萬元",
        data: [
            {
                name: "1萬元以上~未滿2萬元",
                value: "0.0000",
            },
            {
                name: "沒有額外花費",
                value: "1.0000",
            },
            {
                name: "3千元以上~未滿4千元",
                value: "0.0000",
            },
            {
                name: "不記得",
                value: "0.0000",
            },
            {
                name: "4千元以上~未滿5千元",
                value: "0.0000",
            },
            {
                name: "2千元以上~未滿3千元",
                value: "0.0000",
            },
            {
                name: "1千元以上~未滿2千元",
                value: "0.0000",
            },
            {
                name: "7千元以上~未滿8千元",
                value: "0.0000",
            },
            {
                name: "不到1千元",
                value: "0.0000",
            },
            {
                name: "2萬元以上，約萬元【訪員請紀錄】",
                value: "0.0000",
            },
            {
                name: "9千元以上~未滿1萬元",
                value: "0.0000",
            },
            {
                name: "8千元以上~未滿9千元",
                value: "0.0000",
            },
            {
                name: "5千元以上~未滿6千元",
                value: "0.0000",
            },
            {
                name: "6千元以上~未滿7千元",
                value: "0.0000",
            },
        ],
    },
];

function GroupedBarsChart({
    data = MOCK_DATA,
    statisticsType = 1,
    chartTitle = "",
    chart2Title = "",
    chart3Title = "",
    chartNote = "",
}) {
    const svgRef = useRef(null);
    const containerRef = useRef(null);
    const [legends, setLegends] = useState([]);

    useEffect(() => {
        if (!data || data.length === 0) return;

        // 清除舊的圖表
        d3.select(svgRef.current).selectAll("*").remove();

        // 設定圖表尺寸和邊距
        const margin = { top: 20, right: 100, bottom: 40, left: 240 };
        const BAR_HEIGHT = 40;
        const BAR_PADDING = 12;
        const height = (BAR_HEIGHT + BAR_PADDING) * data.length;
        const width =
            Math.min(window.innerWidth, 1440) -
            180 -
            180 -
            margin.left -
            margin.right;

        // 創建 SVG
        const svg = d3
            .select(svgRef.current)
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .append("g")
            .attr("transform", `translate(${margin.left},${margin.top})`);

        // 準備數據
        const yAxisLabels = data.map(d => d.name);
        const stackKeys = data[0].data.map(d => d.name);

        // 修改資料轉換的部分
        const transformedData = yAxisLabels.map(label => {
            const obj = { name: label };
            const item = data.find(d => d.name === label);
            if (item) {
                item.data.forEach(d => {
                    obj[d.name] = parseFloat(d.value);
                });
            }
            return obj;
        });

        // 設定堆疊
        const stackedData = d3
            .stack()
            .keys(stackKeys)
            .value((d, key) => d[key] || 0)(transformedData);

        // 設定 y 軸比例尺（類別）
        const y = d3
            .scaleBand()
            .domain(yAxisLabels)
            .range([0, height])
            .padding(0.3);

        // 設定 x 軸比例尺
        const x = d3
            .scaleLinear()
            .domain([
                0,
                statisticsType === STATISTIC_TYPES.百分比.value
                    ? 1
                    : d3.max(stackedData, (d) => d3.max(d, (d) => d[1])),
            ])
            .range([0, width])
            .nice();

        // 獲取 x 軸的刻度值
        const xTicks = x.ticks(10).map(d => d);

        // 添加垂直背景條紋
        svg.selectAll(".background-stripe")
            .data(xTicks)
            .join("rect")
            .attr("class", "background-stripe")
            .attr("x", (d, i) => x(xTicks[i]))
            .attr("y", 0)
            .attr("width", (d, i) => {
                if (i === xTicks.length - 1) return 0;
                return x(xTicks[i + 1]) - x(xTicks[i]);
            })
            .attr("height", height)
            .attr("fill", (d, i) => (i % 2 === 0 ? "#F9F9F9" : "#fff"))
            .attr("opacity", 0.4)
            .attr("stroke", "#D2D2D2")
            .attr("stroke-width", 1);

        // 設定顏色比例尺
        const color = d3.scaleOrdinal()
            .domain(stackKeys)
            .range(COLOR_ORDINAL);

        // 繪製堆疊長條
        const layers = svg
            .selectAll("g.layer")
            .data(stackedData)
            .join("g")
            .attr("class", "layer")
            .attr("fill", (d) => color(d.key));

        const toolTipDom = containerRef.current.querySelector("#tooltip");

        layers
            .selectAll("rect")
            .data((d) => d)
            .join("rect")
            .attr("y", (d) => y(d.data.name))
            .attr("x", (d) => x(d[0]))
            .attr("height", y.bandwidth())
            .attr("width", (d) => x(d[1]) - x(d[0]))
            .each(function (d) {
                const width = x(d[1]) - x(d[0]);
                if (width > 30) {
                    const value = d[1] - d[0];
                    const stackKey = d3.select(this.parentNode).datum().key;
                    const xPosition = x(d[0]) + width / 2;
                    const yPosition = y(d.data.name) + y.bandwidth() / 2;

                    d3.select(this.parentNode)
                        .append("text")
                        .attr("x", xPosition)
                        .attr("y", yPosition)
                        .attr("dy", "0.35em")
                        .attr("text-anchor", "middle")
                        .attr("fill", "white")
                        .attr("font-size", "12px")
                        .text(
                            statisticsType === STATISTIC_TYPES.百分比.value
                                ? `${Math.round(value * 100)}%`
                                : Math.round(value)
                        );
                }
            })
            .on("mouseenter", function (d, i) {
                const mousePosition = d3.mouse(this);
                const value = d[1] - d[0];
                const stackKey = d3.select(this.parentNode).datum().key;
                const svgWidth = svg.node().getBoundingClientRect().width;

                // 判斷是否靠近左側邊緣
                if (mousePosition[0] < svgWidth / 2) {
                    toolTipDom.classList.remove(styles.tooltipLeft);
                    toolTipDom.classList.add(styles.tooltipRight);
                    toolTipDom.style.left = `${mousePosition[0]}px`;
                } else {
                    toolTipDom.classList.remove(styles.tooltipRight);
                    toolTipDom.classList.add(styles.tooltipLeft);
                    toolTipDom.style.left = `${mousePosition[0]}px`;
                }

                const tooltipContent = chart3Title
                    ? `${chart2Title}：${
                          d.data && d.data.name ? d.data.name : ""
                      }\n${chart3Title}：${stackKey}\n${chartTitle}的${
                          FIND_STATISTIC_TYPE_BY_VALUE(statisticsType).label
                      }：${
                          statisticsType === STATISTIC_TYPES.百分比.value
                              ? `${Math.round(value * 100)}%`
                              : Math.round(value)
                      }`
                    : `${chartTitle}：${
                          d.data && d.data.name ? d.data.name : ""
                      }\n${chart2Title}：${stackKey}\n${chartTitle}的${
                          FIND_STATISTIC_TYPE_BY_VALUE(statisticsType).label
                      }：${
                          formatNumber(value, FIND_STATISTIC_TYPE_BY_VALUE(statisticsType).value)
                      }`;

                toolTipDom.style.top = `${mousePosition[1]}px`;
                toolTipDom.style.opacity = 1;
                toolTipDom.innerHTML = tooltipContent;
            })
            .on("mousemove", function () {
                const mousePosition = d3.mouse(this);
                toolTipDom.style.left = `${mousePosition[0]}px`;
                toolTipDom.style.top = `${mousePosition[1]}px`;
            })
            .on("mouseleave", function () {
                toolTipDom.style.opacity = 0;
            });

        // 添加 y 軸
        svg.append("g")
            .call(d3.axisLeft(y))
            .selectAll("text")
            .style("text-anchor", "end")
            .style("font-size", "14px")
            .each(function (d) {
                const text = d3.select(this);
                if (!d) {
                    text.text("");
                    return;
                }
                if (d.includes("~")) {
                    const parts = d.split("~");
                    text.text("")
                        .append("tspan")
                        .text(parts[0] + "~")
                        .attr("x", -10)
                        .attr("dy", 0);
                    text.append("tspan")
                        .text(parts[1])
                        .attr("x", -10)
                        .attr("dy", "1.2em");
                } else if (d.includes("【訪員請紀錄】")) {
                    const parts = d.split("【訪員請紀錄】");
                    text.text("")
                        .append("tspan")
                        .text(parts[0])
                        .attr("x", -10)
                        .attr("dy", 0);
                    text.append("tspan")
                        .text("【訪員請紀錄】" + parts[1])
                        .attr("x", -10)
                        .attr("dy", "1.2em");
                } else if (d.length > 6) {
                    const midpoint = Math.ceil(d.length / 2);
                    const line1 = d.slice(0, midpoint);
                    const line2 = d.slice(midpoint);
                    text.text("");
                    text.append("tspan")
                        .text(line1)
                        .attr("x", -10)
                        .attr("dy", 0);
                    text.append("tspan")
                        .text(line2)
                        .attr("x", -10)
                        .attr("dy", "1.2em");
                }
            });

        // 添加 x 軸
        svg.append("g")
            .attr("transform", `translate(0,${height})`)
            .call(
                d3
                    .axisBottom(x)
                    .ticks(
                        10,
                        statisticsType === STATISTIC_TYPES.百分比.value
                            ? "%"
                            : undefined
                    )
            )
            .selectAll("text")
            .style("font-size", "14px");

        setLegends(
            stackKeys.map(key => ({
                name: key,
                color: color(key)
            }))
        );
    }, [data, statisticsType]);

    return (
        <div className={`${styles.groupBarsChartContainer} stack-bars-chart`}>
            <Legend
                title={chart2Title}
                items={legends}
                className={styles.legend}
            />
            <div className={styles.groupBarsChart} ref={containerRef}>
                <div id="tooltip" className={styles.tooltip}></div>
                <svg ref={svgRef}></svg>
            </div>
            {chartNote && (
                <ChartNote chartNote={chartNote} className={styles.chartNote} />
            )}
        </div>
    );
}

export default GroupedBarsChart;
